<template>
    <div class="proposal">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="24">
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    :inline="true"
                    label-width="100px"
                    class="demo-ruleForm"
                >
                    <el-col>
                        <el-form-item label="建议标题" prop="title">
                            <el-input
                                class="long"
                                maxlength="30"
                                v-model="ruleForm.title"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="运单号" prop="waybill">
                            <el-input
                                class="long"
                                maxlength="12"
                                v-model="ruleForm.waybill"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item class="black" label="留言人" prop="name">
                            <el-input
                                class="code"
                                maxlength="15"
                                v-model="ruleForm.name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            class="black"
                            label="联系方式"
                            prop="phone"
                        >
                            <el-input
                                class="tele"
                                maxlength="12"
                                v-model="ruleForm.phone"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-form-item label="详细内容" prop="content">
                        <el-input
                            class="long"
                            type="textarea"
                            maxlength="50"
                            v-model="ruleForm.content"
                        ></el-input>
                    </el-form-item>
                    <el-col>
                        <el-form-item label="验证码" prop="captcha">
                            <el-input
                                class="code"
                                maxlength="4"
                                v-model="ruleForm.captcha"
                            ></el-input>
                        </el-form-item>
                        <span class="erification">
                            <img :src="captchaUrl" alt="点击刷新" id="img" />
                        </span>
                        <span class="huanyi" @click="changeCaptcha()"
                            >看不清，换一张?</span
                        >
                    </el-col>
                    <el-col>
                        <el-form-item class="btn">
                            <el-button @click="resetForm('ruleForm')"
                                >重填</el-button
                            >
                            <el-button
                                :disabled="disabled"
                                @click="submitForm('ruleForm')"
                                type="primary"
                                >提交</el-button
                            >
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { saveAdvise } from "@/api/guestBook";
var i = 1;
export default {
    name: "proposal",
    data() {
        return {
            ruleForm: {
                title: "",
                waybill: "",
                name: "",
                phone: "",
                content: "",
                captcha: "",
                type: "1",
                platform: "1"
            },
            disabled: false,
            captchaUrl: "",
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 30,
                        message: "最多只支持输入30个字",
                        trigger: "blur"
                    }
                ],
                waybill: [
                    {
                        required: true,
                        message: "请输入运单号",
                        trigger: "blur"
                    },
                    {
                        min: 12,
                        max: 12,
                        message: "运单号为12位",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[0-9]+$/,
                        message: "只能输入数字"
                    }
                ],
                name: [
                    {
                        required: true,
                        message: "请输入留言人",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 15,
                        message: "最多只支持输入15个字",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    {
                        min: 7,
                        max: 12,
                        message: "电话号码7~12位",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[0-9]+$/,
                        message: "只能输入数字"
                    }
                ],
                content: [
                    {
                        required: true,
                        message: "请输入详细内容",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "最多只支持输入50个字",
                        trigger: "blur"
                    }
                ],
                captcha: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            this.changeCaptcha();
        }
    },
    created() {
        this.getCaptcha();
    },
    mounted() {
        this.changeCaptcha();
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.disabled = true;
                    setTimeout(() => {
                        this.disabled = false;
                    }, 500);
                    saveAdvise(this.ruleForm)
                        .then(res => {
                            if (res.status === 2000) {
                                this.$message({
                                    message: "保存成功！",
                                    duration: "2000",
                                    type: "success"
                                });
                                this.resetForm(formName);

                                this.changeCaptcha();
                            } else if (res.status === 4102) {
                                this.$message({
                                    message: res.data,
                                    type: "warning"
                                });
                                this.changeCaptcha();
                            } else {
                            }
                        })
                        .catch(err => {});
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changeCaptcha() {
            this.captchaUrl = this.GLOBAL + "nologinsystem/captcha?" + i++;
        }
    }
};
</script>
<style lang="scss" scoped>
.proposal {
    position: relative;
    .el-form {
        width: 860px;
        margin-top: 60px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        .long {
            width: 672px;
        }
        .code {
            width: 198px;
        }
        .tele {
            width: 363px;
        }
        .btn {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 30px;
            margin-bottom: 60px;
        }
        .erification {
            display: inline-block;
            width: 160px;
            height: 38px;
            border: 1px solid #ccc;
            img {
                width: 160px;
                height: 38px;
            }
        }
        .huanyi {
            cursor: pointer;
            position: relative;
            bottom: 12px;
            left: 20px;
        }
    }
}
</style>
